// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.properties.addresses.RentalManagerPropertyAddressDetailsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerPropertyAddressDetailsWebApiHandler_details,
  RentalManagerPropertyAddressDetailsWebApiHandler_details_Path,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type { PropertyAddressDetailsWebResponseDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

interface DetailsParams {
  city?: string;
  fullAddress?: string;
  state?: string;
  street?: string;
  unit?: string;
  zip?: string;
}

export type RentalManagerPropertyAddressDetailsWebApiHandler_details_Options = UseQueryOptions<
  PropertyAddressDetailsWebResponseDto,
  unknown,
  PropertyAddressDetailsWebResponseDto,
  readonly [string, DetailsParams]
>;

const RentalManagerPropertyAddressDetailsWebApiHandler_details_GetKey = (getParams: DetailsParams) =>
  [RentalManagerPropertyAddressDetailsWebApiHandler_details_Path, getParams] as const;

export const RentalManagerPropertyAddressDetailsWebApiHandler_details_queryOptions = (
  getParams: DetailsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerPropertyAddressDetailsWebApiHandler_details_GetKey(getParams),
    queryFn: () => RentalManagerPropertyAddressDetailsWebApiHandler_details(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get property details for non authenticated users
 */
export const useRentalManagerPropertyAddressDetailsWebApiHandler_details = (
  getParams: DetailsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerPropertyAddressDetailsWebApiHandler_details_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerPropertyAddressDetailsWebApiHandler_details_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerPropertyAddressDetailsWebApiHandler_details.getKey =
  RentalManagerPropertyAddressDetailsWebApiHandler_details_GetKey;
